import React from 'react';

function getTileValue(tile) {
  return typeof tile === 'object' && tile !== null ? tile.value : tile;
}

function getTileColor(tile) {
  return typeof tile === 'object' && tile !== null && tile.color ? tile.color : 'yellow';
}

const Stack = ({ values, onClick, onDropTile, onDragOverTile, dropActive, dropIndex }) => {
  const top = values.length ? values[values.length - 1] : null;
  const topValue = top === null ? null : getTileValue(top);
  const complete = topValue === 13;

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={
        top === null ? `Foundation ${dropIndex + 1}, empty` : `Foundation ${dropIndex + 1}, top tile ${topValue}`
      }
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
      onDrop={onDropTile}
      onDragOver={onDragOverTile}
      data-drop-zone="true"
      data-drop-type="stack"
      data-drop-index={dropIndex}
      className={`well foundation ${dropActive ? 'drop-active' : ''} ${complete ? 'complete' : ''}`}
    >
      {top === null ? (
        <span className="foundation-hint" aria-hidden="true">
          1
        </span>
      ) : (
        <span className={`counter counter-${getTileColor(top)}`} key={values.length}>
          {topValue}
        </span>
      )}
      {values.length > 0 && <span className="foundation-progress">{values.length}/13</span>}
    </div>
  );
};

export default Stack;
